<template>
  <div class="row">
    <div class="small-12 columns">
      <!-- <div v-if="editing">
                <button class="button-font">Previous</button>
                <button @click="nextClick" class="button-font">Next</button>
            </div> -->
      <div>
        <div class="small-3 columns"><br /></div>
        <div class="small-9 columns">
          <span class="label-mcq">Tags</span>
          <qTagAutofill :prop-tags="qtags" />
        </div>
      </div>
      <div style="margin-bottom:10px;padding-top:10px;">
        <div class="small-3 columns">Points</div>
        <div class="small-9 columns">
          <input id="" v-model="points" type="text" name="" />
        </div>
      </div>
      <div class="label-mcq">Question</div>
      <div class="small-9 columns">
        <markdownEditor
          v-if="questionEditing"
          v-model="questionContent"
          class="mcq-markdown-editor"
          @imageAdded="catchImageAddQuestionEvent"
        />
        <div v-if="!questionEditing">
          <div
            id="questioncontent"
            class="mcq-content-rendered-markdown"
            v-html="renderedQuestion"
          />
        </div>
      </div>
      <div class="small-3 columns">
        <button
          :class="questionEditing ? 'button-green' : ''"
          @click="toggleEditQuestion"
        >
          >
          <span v-if="!questionEditing" class="button-font">Edit Question</span>
          <span v-if="questionEditing" class="button-font">Finished</span>
        </button>
      </div>
    </div>
    <div class="small-12 columns">
      <div class="label-mcq">Options</div>
      <div v-for="(option, i) in currentOptions" :key="i" class="row">
        <div
          class="small-9 columns"
          @click="markOptionAsAnswer($event, option.id)"
        >
          <div
            :class="
              findIndexOfIdInOptions(option.id) !== undefined
                ? 'answer-container'
                : 'non-answer-container'
            "
          >
            <markdownEditor
              v-if="isThisOptionBeingEdited(currentEditingOption, i)"
              v-model="option.item"
              class="mcq-markdown-editor"
              @imageAdded="catchImageAddOptionEvent($event, i)"
            />
            <div v-if="!isThisOptionBeingEdited(currentEditingOption, i)">
              <div
                id="questioncontent"
                class="mcq-content-rendered-markdown-option"
                v-html="
                  renderOptionWithMarkdownLinks(option.item, option.attachments)
                "
              />
            </div>
          </div>
        </div>
        <div class="small-3 columns">
          <button
            :class="
              isThisOptionBeingEdited(currentEditingOption, i)
                ? 'button-font button-green'
                : 'button-font'
            "
            @click="selectCurrentEditingOption(i)"
          >
            <span v-if="isThisOptionBeingEdited(currentEditingOption, i)"
              >Finish</span
            >
            <span v-if="!isThisOptionBeingEdited(currentEditingOption, i)"
              >Edit</span
            >
          </button>
          <button
            v-if="!(currentEditingOption === i)"
            class="button-red button-font"
            @click="deleteOption(i, option.id)"
          >
            X
          </button>
        </div>
      </div>
      <div>
        <button class="button-green button-font" @click="addOption">
          Add Option
        </button>
      </div>
    </div>
    <div>
      <div class="label-mcq">Explanation</div>
      <div class="small-9 columns">
        <markdownEditor
          v-if="explanationEditing"
          v-model="explanationContent"
          class="mcq-markdown-editor"
        />

        <div v-if="!explanationEditing">
          <div
            id="questioncontent"
            class="mcq-content-rendered-markdown"
            v-html="renderedExplanation"
          />
        </div>
      </div>
      <div class="small-3 columns">
        <button
          :class="
            explanationEditing ? 'button-green button-font' : 'button-font'
          "
          @click="toggleEditExplanation"
        >
          <span v-if="explanationEditing">Finish</span>
          <span v-if="!explanationEditing">Edit Explanation</span>
        </button>
      </div>
    </div>
    <div class="small-12 columns">
      <button class="button-blue button-font" @click="emitQuestion">
        <span v-if="editing">Update</span> <span v-if="!editing">Add</span>
        <span>Question</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import idGenerator from "@/utils/idGenerator"
// ///
import markdownHelpers from "@/utils/markdownEditorHelpers"
// import VueMarkdown from "vue-markdown"
import markdownEditor from "@/components/questions/MarkdownReadingEditor"
// ///
import qTagAutofill from "@/components/shared/qTagAutofill"

export default {
  components: { markdownEditor, qTagAutofill },
  props: ["mcqObject", "editing"],
  data() {
    return {
      markdownRenderer: undefined,
      points: this.mcqObject.points,
      // ////////////////////////////
      questionEditing: false,
      questionContent: this.mcqObject.content || "Edit Question",
      renderedQuestion: "",
      // //
      // /
      currentOptions: this.mcqObject.list.options,
      answerOptions: this.mcqObject.answers,
      currentEditingOption: undefined,
      //
      renderedExplanation: "edit explanation",
      explanationEditing: undefined,
      explanationContent: this.mcqObject.explain,
      attachments: this.mcqObject.attachments || [],
      //
      finalQuestionObject: {},
      // //
      qtags: this.mcqObject.qtags,
    }
  },
  computed: {
    ...mapGetters("module", [
      "getCurrentTagList",
      "getAddedTags",
      "getDeletedTags",
    ]),
  },
  created() {
    this.markdownRenderer = window.markdownit()
  },
  mounted() {
    this.$nextTick(() => {
      window.Prism.highlightAll()
    })
    this.renderedQuestion = this.markdownRenderer.render(
      markdownHelpers.decodeIDsToMarkdownLinks(
        this.questionContent,
        this.attachments
      )
    )
    this.renderedExplanation = this.markdownRenderer.render(
      this.explanationContent
    )
  },
  methods: {
    catchImageAddOptionEvent(eventObj, i) {
      this.currentOptions[i].item = eventObj.encodedString
      this.currentOptions[i].attachments = eventObj.attachments
    },
    catchImageAddQuestionEvent(eventObj) {
      this.questionContent = eventObj.encodedString
      for (let i = 0; i < eventObj.attachments.length; i++) {
        this.attachments.push(eventObj.attachments[i])
      }
    },
    nextClick() {
      this.$emit("nextQuestionClicked", {})
    },

    toggleEditExplanation() {
      this.explanationEditing = !this.explanationEditing
      this.renderedExplanation = this.markdownRenderer.render(
        this.explanationContent
      )
    },
    isThisOptionBeingEdited(currentEditingOption, i) {
      if (currentEditingOption === i) {
        return true
      }
      return false
    },
    returnRenderedHTML(markdown) {
      return this.markdownRenderer.render(markdown)
    },
    renderOptionWithMarkdownLinks(content, attachments) {
      return this.markdownRenderer.render(
        markdownHelpers.decodeIDsToMarkdownLinks(content, attachments)
      )
    },
    isIdPartOfAnswerArray(id) {
      for (let i = 0; i < this.answerOptions.length; i++) {
        if (this.answerOptions[i].key === id) {
          return true
        }
      }
      return false
    },
    findIndexOfIdInOptions(id) {
      for (let i = 0; i < this.answerOptions.length; i++) {
        if (this.answerOptions[i].key === id) {
          return i
        }
      }
      return undefined
    },
    markOptionAsAnswer(event, id) {
      if (event.ctrlKey === true || event.metaKey === true) {
        if (!this.isIdPartOfAnswerArray(id)) {
          this.answerOptions.push({ key: id })
        } else {
          const index = this.findIndexOfIdInOptions(id)
          this.answerOptions.splice(index, 1)
        }
      }
    },
    addOption() {
      if (this.currentOptions.length < 10) {
        this.selectCurrentEditingOption(this.currentOptions.length)
        this.currentOptions.push({
          id: idGenerator.generatePushID(),
          item: "edit the content here",
          attachments: {},
        })
      }
    },
    deleteOption(arrayIndex, id) {
      this.currentOptions.splice(arrayIndex, 1)
      if (this.isIdPartOfAnswerArray(id)) {
        const index = this.answerOptions.indexOf(id)
        this.answerOptions.splice(index, 1)
      }
    },
    toggleEditQuestion() {
      this.questionEditing = !this.questionEditing
      this.renderedQuestion = this.markdownRenderer.render(
        markdownHelpers.decodeIDsToMarkdownLinks(
          this.questionContent,
          this.attachments
        )
      )
    },
    emitQuestion() {
      if (this.editing) {
        this.finalQuestionObject = {}
        this.finalQuestionObject.points = this.points
        this.finalQuestionObject.content = this.questionContent
        this.finalQuestionObject.list = {}
        this.finalQuestionObject.list.options = this.currentOptions
        this.finalQuestionObject.answers = this.answerOptions
        this.finalQuestionObject.explain = this.explanationContent
        this.finalQuestionObject.id = this.mcqObject.id
        this.finalQuestionObject.ops_qtags = this.getAddedTags.map(
          item => item.id
        )
        this.finalQuestionObject.ops_qtags_unlink = this.getDeletedTags.map(
          item => item.id
        )
        this.finalQuestionObject.attachments = this.attachments
        this.$emit("MCQ_OBJECT_EDIT_EMIT", this.finalQuestionObject)
      } else {
        this.finalQuestionObject = {}
        this.finalQuestionObject.points = this.points
        this.finalQuestionObject.content = this.questionContent
        this.finalQuestionObject.list = {}
        this.finalQuestionObject.list.options = this.currentOptions
        this.finalQuestionObject.answers = this.answerOptions
        this.finalQuestionObject.explain = this.explanationContent
        this.finalQuestionObject.attachments = this.attachments
        this.finalQuestionObject.ops_qtags = this.getCurrentTagList.map(
          item => item.id
        )
        this.$emit("MCQ_OBJECT_CREATE_EMIT", this.finalQuestionObject)
      }
    },
    selectCurrentEditingOption(index) {
      if (index === this.currentEditingOption) {
        this.currentEditingOption = undefined
        return
      }
      this.currentEditingOption = index
    },
  },
}
</script>

<style>
.button-font {
  font-size: 0.7em !important;
}
.label-mcq {
  color: #5c87e6;
  font-weight: 700;
  font-style: italic;
}
.non-answer-container {
  margin-right: 20px;
}
.answer-container {
  margin-right: 20px;
  background-color: #8bc34a;
}
.sweet-modal.is-alert .sweet-content {
  text-align: unset;
}
.mcq-markdown-editor {
  width: 96%;
  margin: auto;
}
.mcq-content-rendered-markdown {
  margin-right: 10px;
  margin-bottom: 30px;
  padding: 10px;
}

.mcq-content-rendered-markdown-option {
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
/*overriding */
.sweet-modal.is-alert .sweet-content {
  display: block;
  padding-top: 64px;
  padding-bottom: 64px;
  font-size: 16px;
  text-align: left !important;
}
</style>

<style scoped>
.columns > button,
div > button {
  padding: 10px;
  border: 1px solid grey;
  border-radius: 100px;
}
div > input {
  width: 100%;
  margin: 10px;
  padding: 10px;
}
</style>
